<template>
    <a-table class="mb-20" :columns="columns" :loading="viewTableLoading" :data-source="data" bordered :pagination="{ pageSize: 5 ,position: 'top', }">
        
        <template slot="detail" slot-scope="text">
            
            <p class="mt-0 mb-0" :style="{ fontWeight: 'bold', fontSize: '16px' }"> <a-icon theme="twoTone"
                    :style="{ color: '#005B41' }" class="mr-2" type="car" /> {{ text.destination }}</p>
            <p class="mt-0 mb-10 font-web text-muted"><i>{{ text.reason_detail.eng_detail }}</i></p>
            <p class="mt-0 mb-0" :style="{ fontSize: '14px' }">
                <b>Start ::</b> {{ moment(text.use_start).format("DD / MM / YYYY , HH:mm:ss") }}
            </p>
            <p class="mt-0 mb-0" :style="{ fontSize: '14px' }">
                <b>End ::</b> {{ moment(text.use_end).format("DD / MM / YYYY , HH:mm:ss") }}
            </p>
        </template>
        <template slot="service" slot-scope="text">
            <a-list class="">
                <a-list-item>
                    <a-list-item-meta>
                        <p class="mt-0 mb-0" slot="title">{{ `${text.driver_detail.driver_detail.name}
                                                    ${text.driver_detail.driver_detail.surname}` }}</p>
                        <a-avatar :size="35" shape="square" slot="avatar" :src="text.driver_detail.driver_detail.img" />
                        <span slot="description">
                            <p class="mt-0 mb-0">{{ text.driver_detail.driver_detail.email }}</p>
                            <!-- <hr> -->
                            <p class="mt-0 mb-0"><strong>Office Phone :</strong> {{
                                text.driver_detail.driver_detail.telephone }}</p>
                            <p class="mt-0 mb-0"><strong>Phone :</strong> {{ text.driver_detail.tel }}</p>
                            <!-- <hr> -->
                            <p class="mt-0 mb-0"><strong>Car :</strong> {{ text.car_detail.code }}</p>
                        </span>
                    </a-list-item-meta>
                </a-list-item>
            </a-list>
        </template>
        <template slot="title" slot-scope="currentPageData">
            <a-space>
                <a-date-picker v-model="inputStart" :disabled-date="disabledBlockDate" format="YYYY-MM-DD"
                    :mode="['date']" />
                <strong>to</strong>
                <a-date-picker :disabled="['', null].includes(inputStart)" v-model="inputEnd"
                    :disabled-date="disabledEndDate" :mode="['date']" />
                <a-button :disabled="['', null].includes(inputStart) || ['', null].includes(inputEnd)" type="primary" icon="search" @click="getTableViewMode" />
            </a-space>
        </template>
        <template slot="footer" slot-scope="currentPageData">
            All Vehicle Booking {{ data.length }} Request.
        </template>
    </a-table>
</template>
<script>
const columns = [
    {
        title: 'Detail',
        className: 'column-money',
        scopedSlots: { customRender: 'detail' },
        width: 700,
    },
    {
        title: 'Driver & Car',
        scopedSlots: { customRender: 'service' },
    },
];

const data = [];

export default {
    data() {
        return {
            data,
            columns,
            inputStart: `${this.moment().format("YYYY-MM-DD")}`,
            inputEnd: `${this.moment().format("YYYY-MM-DD")}`,
            viewTableLoading: false,
        };
    },
    computed: {
        changeData() {
            const { inputStart } = this;
            return {
                inputStart,
            };
        },
    },
    watch: {
        changeData: {
            handler: function (val) {
                this.data = []
                this.inputEnd = ''
            },
            deep: true,
        },
    },
    mounted() {
        this.getTableViewMode()
    },
    methods: {
        disabledBlockDate(date) {
            let arr = Number.parseInt(this.moment().format("MM")) - 1
            if (Number.parseInt(date._d.getMonth() + 1) >= arr) {
                return false
            } else {
                return true
            }
        },
        disabledEndDate(endValue) {
            return this.moment(endValue).format("YYYY-MM-DD") < this.moment(this.inputStart).format("YYYY-MM-DD");
        },
        async getTableViewMode() {
            this.viewTableLoading = true
            this.data = []
            let start = `${this.moment(this.inputStart).format("YYYY-MM-DD")}T00:00:00+07:00`;
            let End = `${this.moment(this.inputEnd).format("YYYY-MM-DD")}T23:59:59+07:00`;
            try {
                const res = await this.$http.get(`/vehicle/booking/calendar/?timestart=${encodeURIComponent(start)}&timeend=${encodeURIComponent(End)}&status=approve,success`);
                if (res.status === 200) {
                    this.data = res.data
                    this.data.sort(function (a, b) {
                        let nameA = a.use_start.toUpperCase();
                        let nameB = b.use_start.toUpperCase();
                        if (nameA < nameB) {
                            return -1;
                        }
                        if (nameA > nameB) {
                            return 1;
                        }
                        return 0;
                    });
                    this.viewTableLoading = false;
                }else{
                    const error = new Error('Request Failed');
                    error.res = res;
                    error.response = res;
                    throw error;
                }
            } catch (error) {
                this.openNotification({
                    title: `Error ${error.response.status}`,
                    msg: `Problem issue connect api : /vehicle/booking/calendar/?timestart=${encodeURIComponent(start)}&timeend=${encodeURIComponent(End)}&status=approve,success`,
                    backgroundColor: "#ff1919",
                    color: "#ffffff",
                });
                this.viewTableLoading = false;
            }
        }
    }
};
</script>
<style>
th.column-money,
td.column-money {
    text-align: left !important;
}
</style>
  